var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4,
    transform: "rotate(-180 6 6)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.3 12 12 9.3 12 6C12 2.7 9.3 -2.36042e-07 6 -5.24537e-07C2.7 -8.13032e-07 8.13032e-07 2.7 5.24537e-07 6C2.36042e-07 9.3 2.7 12 6 12ZM3.78 4.62C3.54 4.38 3.54 4.02 3.78 3.78C4.02 3.54 4.38 3.54 4.62 3.78L6 5.16L7.38 3.78C7.62 3.54 7.98 3.54 8.22 3.78C8.46 4.02 8.46 4.38 8.22 4.62L6.84 6L8.22 7.38C8.46 7.62 8.46 7.98 8.22 8.22C7.98 8.46 7.62 8.46 7.38 8.22L6 6.84L4.62 8.22C4.38 8.46 4.02 8.46 3.78 8.22C3.54 7.98 3.54 7.62 3.78 7.38L5.16 6L3.78 4.62Z",
    fill: "#E75113"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclined);
export default __webpack_public_path__ + "static/media/declined.30964658469b008a05d317809e0a7396.svg";
export { ForwardRef as ReactComponent };